import React from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';

const ErrorMessages = ({ error }) => {
  const locale = localStorage.getItem('locale')
  return (
    <>
      <h2>
        <div id="main-content-title">
          <span
            className="frg-icon icon-user-profile-inverted"
            style={{ paddingRight: 10, fontSize: 26 }}
          />
          {locale === 'FR' ? 'Mot de passe oublié' :'Forgotten Password'}
        </div>
      </h2>
      {error ? (
        <div id="error-message-content" style={{ display: 'block' }}>
          <div id="error-message-icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
          <div id="error-message-title">
            <span className="frg-body-font-23px">{locale === 'FR' ? 'Un problème est survenu!' : 'Something went wrong!'}</span>
          </div>
          <div className="clear" />
          <div id="error-message-message">
            <span className="frg-body-font-14px">
              {error}
              <br />
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
};

ErrorMessages.propTypes = {
  error: PropTypes.bool.isRequired
};
export default ErrorMessages;
